module.exports = __webpack_public_path__ + "assets/img/9d2d20a8f5edef7ba9dd2eafe4f2991e.png";